import React from "react";
import { YieldBasis } from "../types/ownerDashboard.types";
import MetricInfoTooltip from "../components/MetricInfoTooltip";
import {
  MARKET_VALUE_YIELD_INFO_LABEL,
  MARKET_VALUE_YIELD_TOOLTIP_TITLE,
  getMarketValueYieldTooltipDescription,
} from "../constants/marketValueYieldTooltip";

interface YieldBasisToggleProps {
  value: YieldBasis;
  onChange: (value: YieldBasis) => void;
}

const OPTIONS: { value: YieldBasis; label: string }[] = [
  { value: "purchase_value", label: "Sobre valor de aquisição" },
  { value: "market_value", label: "Sobre valor de mercado" },
];

export default function YieldBasisToggle({ value, onChange }: YieldBasisToggleProps) {
  return (
    <div className="flex w-full flex-col gap-1.5">
      <div className="flex items-center gap-1.5">
        <span className="text-[0.65rem] font-semibold uppercase tracking-wider text-[#6e7681]">
          Base do rendimento
        </span>
        <MetricInfoTooltip
          variant="subtle"
          title={MARKET_VALUE_YIELD_TOOLTIP_TITLE}
          description={getMarketValueYieldTooltipDescription()}
          ariaLabel={MARKET_VALUE_YIELD_INFO_LABEL}
        />
      </div>
      <div className="flex w-full gap-2 rounded-2xl border border-white/[0.08] bg-[#0d1117]/60 p-1">
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`flex-1 rounded-xl px-3 py-2 text-xs font-semibold transition-colors sm:text-sm ${
              value === option.value
                ? "bg-[#6ea8ff]/20 text-[#6ea8ff]"
                : "text-[#8b949e] hover:bg-white/5"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
